<template>
  <button :disabled = "disabled"
          @click="() => $emit('click')"
          :class="[
            $style.button,
            outline && $style.outline,
            outlineBlue && $style.outlineBlue,
            lightBlue && $style.lightBlue,
            sm && $style.sm,
  ]">
    <slot />
  </button>
</template>
<script>
export default {
  name: 'Button',
  props: {
    outline: Boolean,
    lightBlue: Boolean,
    outlineBlue: Boolean,
    sm: Boolean,
    disabled: Boolean,
  },
}
</script>
<style lang="scss" module>
.button {
  background: #3740E2;
  appearance: none;
  border: 0;
  font-size: 2.4rem;
  color: #fff;
  height: 8rem;
  line-height: 8rem;
  padding: 0 3rem;
  border-radius: 1rem;
  box-shadow: 0 0.6rem 1rem rgba(0, 0, 0, 0.15), 0 0.1rem 0.3rem rgba(0, 0, 0, 0.2);
  font-weight: bold;
  outline: none;
  transition: box-shadow 0.4s ease;
  white-space: nowrap;

  &:hover {
    box-shadow: 0 0.6rem 0.4rem rgba(0, 0, 0, 0.15), 0 0.1rem 0.3rem rgba(0, 0, 0, 0.2);
  }

  &:active {
    box-shadow: none;
  }

  &:disabled,
  &[disabled] {
    opacity: 0.5;
  }

  @media #{$m-mobile} {
    font-size: 1.2rem;
    height: 4rem;
    line-height: 4rem;
    padding: 0 1rem;
  }
}

.outline {
  background: none;
  box-shadow: none !important;
  border: 1px solid #fff;
  min-width: 18rem;

  @media #{$m-mobile} {
    min-width: 13rem;
  }
}

.outlineBlue {
  background: none;
  box-shadow: none !important;
  border: 1px solid #3740E2;
  color: #3740E2;
  min-width: 18rem;

  @media #{$m-mobile} {
    min-width: 13rem;
  }
}

.lightBlue {
  background: $app-vk;
}

.sm {
  height: 3rem;
  padding: 0 1.4rem;
  font-size: 1.8rem;
  line-height: 1.8rem;

  @media #{$m-mobile} {
    height: 2rem;
    padding: 0 1rem;
    font-size: 1rem;
    line-height: 2rem;
    border-radius: 6px;
  }
}
</style>
